import React from "react";
import { object, string, func, bool } from "prop-types";
import { Row, Col, Card } from "react-bootstrap";
import warningIcon from "resources/images/warning-brownish@3x.png";
import { supportedTests } from "../constants";
import {
  renderTestSummaryContent,
  getInvalidWarningRow,
  renderDownloadButton,
} from "../renderHelpers";
import { showInvalidTestWarning } from "../helpers";

const TestSummarySection = ({
  handleDownloadPdf,
  handleViewDetailsButton,
  test,
  testId,
  hideBaseline,
}) => {
  const isTestMakerTest = testId.substring(0, 2).toUpperCase() === "TM";
  const isSupportedTest =
    supportedTests.includes(Number(testId)) || isTestMakerTest;

  /* --------- Begin rendering logic ---------  */
  const showInvalidWarningRow = showInvalidTestWarning(
    Number(testId),
    test.get("report")
  );

  const [
    SummaryHeader,
    ScoreBoxes,
    ScoreScaleSection,
    ScoreRangeSection,
    AdditionalText,
  ] = renderTestSummaryContent(
    test,
    testId,
    isSupportedTest,
    handleViewDetailsButton,
    hideBaseline
  );

  const DownloadButton = (
    <span
      className="text-right"
      style={{
        width: "170px",
        marginRight: "-8px",
      }}
    >
      {renderDownloadButton(
        handleDownloadPdf,
        testId,
        "Report",
        !isSupportedTest,
        test.get("test").get("testName")
      )}
    </span>
  );

  const fullSectionBoxesTests = [
    16, 17, 18, 21, 22, 32, 33, 35, 36, 37, 38, 39, 40, 41, 43, 53, 54, 55, 57,
  ];
  const showFullSectionBoxes = Boolean(
    (fullSectionBoxesTests.includes(Number(testId)) || isTestMakerTest) &&
      !ScoreRangeSection
  );

  return (
    <Row
      className="mt-3 pt-3 pb-4 mx-1"
      style={{ borderTop: "2px solid black" }}
      key={testId}
    >
      <Col className="px-0">
        {SummaryHeader}
        <hr className="mt-0" />
        {isSupportedTest ? (
          <Row style={{ margin: "0 2px" }}>
            {ScoreBoxes.length > 0 && (
              <Col lg={showFullSectionBoxes ? null : 4}>
                <Row>{ScoreBoxes}</Row>
                {showInvalidWarningRow && getInvalidWarningRow(testId)}
              </Col>
            )}
            {AdditionalText || null}
            {ScoreRangeSection || ScoreScaleSection ? (
              <Col>
                {ScoreRangeSection}
                {ScoreBoxes.length === 0 &&
                  showInvalidWarningRow &&
                  getInvalidWarningRow(testId)}
                <Row
                  className="mt-3"
                  style={{
                    marginLeft: ScoreBoxes.length === 0 ? "-15px" : "5px",
                    marginRight: ScoreBoxes.length === 0 ? "30px" : "5px",
                  }}
                >
                  {ScoreScaleSection}
                </Row>
              </Col>
            ) : null}
          </Row>
        ) : (
          <Card
            className="p-0"
            style={{
              backgroundColor: "#fff5e5",
              border: "1px solid #ffedcc",
              marginBottom: "16px",
              color: "#805100",
            }}
          >
            <Card.Body
              className="d-flex justify-content-between"
              style={{ padding: "12px 14px" }}
            >
              <div className="d-flex" style={{ marginTop: "5px" }}>
                <img
                  className="mr-3"
                  src={warningIcon}
                  height="16px"
                  width="16px"
                  alt="warning"
                />
                <p className="mb-0">
                  The results for this assessment are not currently supported in
                  this view; please download the PDF Reports or login to
                  Criteria to view results.
                </p>
              </div>
              {DownloadButton}
            </Card.Body>
          </Card>
        )}
      </Col>
    </Row>
  );
};

TestSummarySection.propTypes = {
  handleDownloadPdf: func.isRequired,
  handleViewDetailsButton: func.isRequired,
  test: object.isRequired,
  testId: string.isRequired,
  hideBaseline: bool,
};

export default TestSummarySection;
